export const STALE_DATA_NOTICE_THRESHOLD_MS = 5 * 60 * 1000 // 5 minutes

export function parseLastReadingAt(iso: string | null | undefined): number | null {
  if (!iso) return null
  const sentAt = new Date(iso).getTime()
  return Number.isNaN(sentAt) ? null : sentAt
}

export function getLastDataAgeLabel(
  lastReadingAtMs: number | null,
  nowMs: number,
  noRecentReadingLabel: string,
): string {
  if (!lastReadingAtMs) return noRecentReadingLabel

  const diffMs = Math.max(0, nowMs - lastReadingAtMs)
  const seconds = Math.floor(diffMs / 1000)
  if (seconds < 60) return 'menos de 1 minuto'

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min atrás`

  const hours = Math.floor(minutes / 60)
  const restMinutes = minutes % 60
  if (hours < 24) return restMinutes > 0 ? `${hours}h, ${restMinutes}min atrás` : `${hours}h atrás`

  const days = Math.floor(hours / 24)
  const restHours = hours % 24
  return restHours > 0 ? `${days}d ${restHours}h atrás` : `${days}d atrás`
}

export function shouldShowStaleDataNotice(
  lastReadingAtMs: number | null,
  nowMs: number,
): boolean {
  if (!lastReadingAtMs) return true
  return nowMs - lastReadingAtMs >= STALE_DATA_NOTICE_THRESHOLD_MS
}

export function getLastPointFromGroupedReadings(
  readings: unknown,
): { t?: string; v?: number; s?: string } | null {
  if (!readings || typeof readings !== 'object') return null

  const groups = Object.values(readings as Record<string, unknown>)
  for (const group of groups) {
    if (!Array.isArray(group) || group.length === 0) continue
    const last = group[group.length - 1]
    if (last && typeof last === 'object') {
      const typed = last as { t?: string; v?: number; s?: string }
      if (typed.t) return typed
    }
  }
  return null
}
